import { createFileRoute } from "@tanstack/react-router";
import { UnsubscribePage } from "@/features/unsubscribe/UnsubscribePage";

/** Public unsubscribe page for one campaign recipient. Sits outside the _app layout, so there is no app shell. */
export const Route = createFileRoute("/p/unsubscribe/$token")({
  component: UnsubscribeRoute,
});

function UnsubscribeRoute() {
  const { token } = Route.useParams();
  return <UnsubscribePage token={token} />;
}
